// assets/titan-ai.js
(() => {
  // ====== 設定 ======
  const WORKER_URL = "https://pc-ai-relay.vercel.app/api/chat";
  const SESSION_KEY = "ai_session_id";
  const STORAGE_KEY = "ai_chat_history_v1";
  const GUARD_KEY   = "ai_chat_guard_v1";
  const BLOCK_KEY   = "ai_spam_blocked_v1";
  const KEEP_MS = 7*24*60*60*1000;

  const RATE_MS = 1000;
  const SPAM_WINDOW = 30 * 1000;
  const SPAM_LIMIT  = 7;
  const REPEAT_LIMIT = 15;
  const UNLOCK_CODE = "たいたんちゃんかわいい";
  const BLOCK_TTL   = 24*60*60*1000;

  const HINT_KEY   = "ai_hint_hidden_ts";
  const HINT_TTL   = 24*60*60*1000;
  /* 商品ページの「AIに質問する」から開いた時、その商品を話題にしている状態（タブ内だけ保持） */
  const PCTX_KEY   = "ai_page_product_v1";
  const PCTX_OFF_KEY = "ai_page_product_off_v1";
  /* 商品ごとの相談履歴（{handle: [...]}）。その他のご相談は STORAGE_KEY のまま */
  const PSTORE_KEY = "ai_chat_product_v1";

  /* リクエスト署名（curl直叩き防止） */
  const _SALT = 'T1t4nG#2025xQ';
  function _djb2(s){let h=5381;for(let i=0;i<s.length;i++){h=((h<<5)+h+s.charCodeAt(i))>>>0;}return h.toString(36);}
  function _sign(){const t=Math.floor(Date.now()/1000);return{_t:t,_k:_djb2(_SALT+':'+t)};}

  /* 相談員アイコン（起動ボタンと同じ図形）ほか固定SVG */
  const AGENT_SVG = '<svg viewBox="0 -960 960 960" aria-hidden="true" focusable="false"><path d="M480-120q-17 0-28.5-11.5T440-160q0-17 11.5-28.5T480-200h280v-284q0-117-81.5-198.5T480-764q-117 0-198.5 81.5T200-484v204q0 17-11.5 28.5T160-240q-33 0-56.5-23.5T80-320v-80q0-21 10.5-39.5T120-469l3-53q8-68 39.5-126t79-101q47.5-43 109-67T480-840q68 0 129 24t109 66.5Q766-707 797-649t40 126l3 52q19 9 29.5 27t10.5 38v92q0 20-10.5 38T840-249v49q0 33-23.5 56.5T760-120H480ZM331.5-411.5Q320-423 320-440t11.5-28.5Q343-480 360-480t28.5 11.5Q400-457 400-440t-11.5 28.5Q377-400 360-400t-28.5-11.5Zm240 0Q560-423 560-440t11.5-28.5Q583-480 600-480t28.5 11.5Q640-457 640-440t-11.5 28.5Q617-400 600-400t-28.5-11.5ZM241-462q-7-106 64-182t177-76q89 0 156.5 56.5T720-519q-91-1-167.5-49T435-698q-16 80-67.5 142.5T241-462Z"/></svg>';
  const TRASH_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5M14 11v5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CLOSE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  const CHEV_R_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHEV_L_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const PC_LINE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="4" width="18" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8.5 20h7M12 16v4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  const FAQ_LINE_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.5v.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="16.9" r="1.1" fill="currentColor"/></svg>';
  const SEND_SVG  = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.993.993 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z"/></svg>';
  /* 入力欄上の質問チップ（表示名 → 送信する質問） */
  const QUICK_QUESTIONS = [
    { label: "予算別のおすすめ", q: "予算別におすすめのゲーミングPCを教えてください。" },
    { label: "納期を知りたい",   q: "注文してから届くまでの納期を教えてください。" },
    { label: "配信にも使える？", q: "ゲーム配信にも使えるPCはありますか？" }
  ];
  /* 商品ページから質問している時の候補チップ */
  const PRODUCT_QUESTIONS = [
    { label: "遊べるゲームは？",   q: "この構成で快適に遊べるゲームと、fpsの目安を教えてください。" },
    { label: "配信にも使える？",   q: "この構成でゲーム配信もできますか？" },
    { label: "カスタマイズの相談", q: "この構成でカスタマイズするなら、どこを変えるのがおすすめですか？" },
    { label: "納期は？",           q: "この商品の納期を教えてください。" }
  ];
  const DIAG_PATH = "/pages/%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8B%E3%82%89%E9%81%B8%E3%81%B6";
  /* 会話の流れに合わせて入れ替える候補チップ（お客様が次に言いそうなこと） */
  const C = (label, q) => ({ label: label, q: q });
  const CHIP = {
    b15:    C("15万円以内で",       "予算15万円以内でおすすめのPCを教えてください。"),
    b20:    C("20万円前後で",       "予算20万円前後でおすすめのPCを教えてください。"),
    b30:    C("30万円前後で",       "予算30万円前後でおすすめのPCを教えてください。"),
    val:    C("VALORANT",           "VALORANTを快適に遊べるPCを教えてください。"),
    apex:   C("Apex",               "Apex Legendsを快適に遊べるPCを教えてください。"),
    mh:     C("モンハンワイルズ",   "モンスターハンターワイルズを快適に遊べるPCを教えてください。"),
    fn:     C("フォートナイト",     "フォートナイトを快適に遊べるPCを教えてください。"),
    wqhd:   C("WQHDで遊びたい",     "WQHD解像度で快適に遊びたいです。"),
    fps:    C("144fps出したい",     "144fps以上を安定して出したいです。"),
    k4:     C("4Kで遊びたい",       "4K解像度で遊びたいです。"),
    stream: C("配信もしたい",       "ゲーム配信もしたいです。配信に向いた構成を教えてください。"),
    mem:    C("メモリ32GBにしたい", "メモリ32GBの構成にしたいです。"),
    ssd:    C("SSDを増やしたい",    "SSDの容量を増やしたいです。おすすめの容量を教えてください。"),
    cheap:  C("もっと安く",         "今の候補より安いPCを教えてください。"),
    up:     C("性能を上げたい",     "今の候補より性能が高いPCを教えてください。"),
    ship:   C("納期を知りたい",     "注文してから届くまでの納期を教えてください。"),
    warr:   C("保証について",       "保証の内容と期間を教えてください。"),
    pay:    C("分割払いできる？",   "分割払いはできますか？支払い方法を教えてください。"),
    pick:   C("おすすめPCを見たい", "おすすめのゲーミングPCを教えてください。")
  };
  const CHIP_RE = {
    budget: /\d+\s*万|予算|円/,
    game:   /valorant|ヴァロ|apex|エーペックス|エペ|モンハン|モンスターハンター|ff14|ffxiv|ファイナルファンタジー|フォートナイト|fortnite|原神|スト6|ストリートファイター|マイクラ|マインクラフト|minecraft|pubg|オーバーウォッチ|overwatch|タルコフ|サイバーパンク|cyberpunk|ゼンゼロ|鳴潮|崩壊|パルワールド|コールオブデューティ|\bcod\b|バトルフィールド|黒い砂漠/i,
    res:    /fhd|フルhd|1080|wqhd|1440|4k|2160|fps|hz|ヘルツ/i,
    stream: /配信|obs|録画|動画編集/i,
    mem:    /メモリ|32gb|64gb/i,
    ssd:    /ssd|ストレージ|\dtb/i,
    ship:   /納期|届|発送|出荷/,
    warr:   /保証|故障|修理|初期不良/,
    pay:    /支払|払い|分割|ローン|クレジット|振込|代引/,
    askGame:   /(どの|どんな|遊びたい|プレイ\S{0,4})ゲーム|ゲーム(名|タイトル)/,
    askBudget: /ご予算|予算(は|を|感)/,
    askRes:    /解像度|fps|リフレッシュレート|wqhd/i
  };
  const onDiagPage = () => location.pathname === DIAG_PATH || decodeURIComponent(location.pathname) === decodeURIComponent(DIAG_PATH);
  function suggestChips(arr){
    const msgs = (arr || []).filter(m => m && (m.role === "user" || m.role === "assistant"));
    if (!msgs.length) return { list: QUICK_QUESTIONS, diag: false };
    const users = msgs.filter(m => m.role === "user").map(m => String(m.text || ""));
    const userAll = users.join("\n");
    const lastUser = users[users.length - 1] || "";
    let lastA = null;
    for (let i = msgs.length - 1; i >= 0; i--) { if (msgs[i].role === "assistant") { lastA = msgs[i]; break; } }
    const a = lastA ? String(lastA.text || "") : "";
    const cards = !!(lastA && lastA.products && lastA.products.length);
    const has = k => CHIP_RE[k].test(userAll);
    const hasBudget = has("budget"), hasGame = has("game"), hasRes = has("res");
    const support = CHIP_RE.ship.test(lastUser) ? "ship" : CHIP_RE.warr.test(lastUser) ? "warr" : CHIP_RE.pay.test(lastUser) ? "pay" : "";
    const out = [];
    const add = (...keys) => keys.forEach(k => out.push(CHIP[k]));
    // AIが聞き返している項目の答えを優先（複数聞かれたら各2つずつ混ぜる）
    const asks = [];
    if (!hasGame && CHIP_RE.askGame.test(a)) asks.push(["val", "apex", "mh", "fn"]);
    if (!hasBudget && CHIP_RE.askBudget.test(a)) asks.push(["b15", "b20", "b30"]);
    if (!hasRes && CHIP_RE.askRes.test(a)) asks.push(["wqhd", "fps", "k4"]);
    asks.forEach(g => add(...(asks.length > 1 ? g.slice(0, 2) : g)));
    if (cards) add("cheap", "up", "mem");
    if (support && !cards) {
      ["ship", "warr", "pay"].forEach(k => { if (k !== support) add(k); });
      add("pick");
    } else {
      if (!hasBudget) add("b20");
      if (!hasGame) add("val", "apex");
      if (hasGame && !hasRes) add("wqhd", "fps");
      if (!has("stream")) add("stream");
      if (!has("mem")) add("mem");
      if (!has("ssd")) add("ssd");
      add("ship", "warr");
    }
    const said = new Set(users.map(t => t.trim()));
    const seen = new Set();
    const list = [];
    for (const c of out) {
      if (!c || seen.has(c.label) || said.has(c.q)) continue;
      seen.add(c.label); list.push(c);
      if (list.length >= 3) break;
    }
    return { list: list, diag: !support || cards };
  }
  const chipsHtml = (list, diag) => {
    if (!Array.isArray(list)) list = QUICK_QUESTIONS;
    let h = list.map(c => '<button type="button" class="ai-chip" data-q="' + c.q + '">' + c.label + '</button>').join("");
    if (diag && !onDiagPage()) {
      h += '<a class="ai-chip ai-chip--diag" href="' + DIAG_PATH + '">AI診断で選ぶ ›</a>';
    }
    return h;
  };
  const ready = (cb) => {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", cb);
    else cb();
  };

  ready(() => {
    // ====== CSS注入 ======
    const style = document.createElement("style");
    style.textContent = `
      :root{
        --ai-brand:#06C755;
        --ai-brand-hover:#05B14B;
        --ai-border:#e3e9f2;
        --ai-text:#1f2937;
        --ai-ai:#ffffff;
      }

      /* #ai-bubble の CSS は全て titan-config-save.liquid で管理 (iOS Safari 対策) */
      #ai-hint{ display:none; }

      /* 初回案内はパネル表示後に退避する。 */
      body.ai-panel-open .titan-ai-coach{
        opacity:0 !important;
        visibility:hidden !important;
        pointer-events:none !important;
      }

      /* 全面表示になるスマホでは起動FABもパネルの後ろへ退避する。
         PCではパネル直下に残し、同じボタンで閉じられるようにする。 */
      @media (max-width:600px){
        body.ai-panel-open .titan-ai-fab{
          opacity:0 !important;
          visibility:hidden !important;
          pointer-events:none !important;
        }
      }

      /* ===== パネル（PC版） ===== */
      #ai-panel{
        position:fixed; left:16px; bottom:70px; z-index:99999;
        width:420px; max-width:95vw; height:600px; max-height:calc(100vh - 90px);
        background:#eef3f0; border:1px solid #dfe7e2; border-radius:18px; overflow:hidden;
        box-shadow:0 18px 46px rgba(0,0,0,.18);
        display:none; grid-template-rows:64px auto minmax(0,1fr) auto auto;
        color:var(--ai-text);
        font-family:-apple-system,BlinkMacSystemFont,"Hiragino Sans","Hiragino Kaku Gothic ProN","Yu Gothic UI","Meiryo",sans-serif;
      }
      #ai-panel *, #ai-panel *::before, #ai-panel *::after{ box-sizing:border-box; }
      /* 2026-09-28: 開閉アニメ。PCは左下のAI丸から膨らむように、スマホは下からせり上がる。 */
      #ai-panel.is-anim-in{ animation:aiPanelIn .4s cubic-bezier(.22,1,.36,1) backwards; transform-origin:36px 100%; }
      #ai-panel.is-anim-out{ animation:aiPanelOut .18s ease-in forwards; pointer-events:none; }
      @keyframes aiPanelIn{ from{ opacity:0; transform:translateY(16px) scale(.94); } to{ opacity:1; transform:translateY(0) scale(1); } }
      @keyframes aiPanelOut{ from{ opacity:1; transform:translateY(0) scale(1); } to{ opacity:0; transform:translateY(10px) scale(.97); } }
      @media (max-width:600px){
        #ai-panel.is-anim-in{ animation-name:aiPanelInM; transform-origin:50% 100%; }
        #ai-panel.is-anim-out{ animation-name:aiPanelOutM; }
        @keyframes aiPanelInM{ from{ opacity:0; transform:translateY(32px); } to{ opacity:1; transform:translateY(0); } }
        @keyframes aiPanelOutM{ from{ opacity:1; transform:translateY(0); } to{ opacity:0; transform:translateY(24px); } }
      }
      @media (prefers-reduced-motion: reduce){
        #ai-panel.is-anim-in, #ai-panel.is-anim-out{ animation:none; }
      }

      /* ===== スマホ版：フルスクリーンパネル ===== */
      @media (max-width:600px){
        #ai-panel{
          position:fixed;
          top:0; left:0; right:0; bottom:0;
          width:100%; height:100%;
          max-width:100vw; max-height:none;
          border-radius:0;
          border:none;
          grid-template-rows:56px auto minmax(0,1fr) auto auto;
        }
        /* パネル表示中はbodyスクロール無効 */
        body.ai-panel-open{
          overflow:hidden !important;
          position:fixed !important;
          width:100% !important;
          height:100% !important;
        }
      }

      /* ヘッダー */
      #ai-head{
        grid-row:1; background:var(--ai-brand); color:#fff;
        display:flex; align-items:center; gap:10px; padding:0 8px 0 14px;
      }
      .ai-head-av{
        width:38px; height:38px; border-radius:50%; background:#fff;
        display:flex; align-items:center; justify-content:center; flex-shrink:0;
      }
      .ai-head-av svg{ width:24px; height:24px; fill:var(--ai-brand); display:block; }
      .ai-head-text{ flex:1; min-width:0; }
      .ai-title{
        display:block; font-weight:800; font-size:15px; line-height:1.25; letter-spacing:.01em;
        white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
      }
      .ai-sub{
        display:flex; align-items:center; gap:5px; margin-top:2px;
        font-size:11.5px; line-height:1.3; color:rgba(255,255,255,.92);
      }
      .ai-sub::before{ content:""; width:7px; height:7px; border-radius:50%; background:#fff; flex-shrink:0; }
      #ai-panel .ai-icon-btn{
        width:40px; height:40px; min-width:0; min-height:0; margin:0; padding:0;
        border:none; border-radius:10px; background:transparent; color:#fff; box-shadow:none;
        display:flex; align-items:center; justify-content:center; flex-shrink:0;
        cursor:pointer; line-height:1; transition:background .15s ease;
      }
      #ai-panel .ai-icon-btn:hover{ background:rgba(255,255,255,.16); }
      #ai-panel .ai-icon-btn:focus-visible{ outline:2px solid #fff; outline-offset:-3px; }
      #ai-panel .ai-icon-btn svg{ width:20px; height:20px; display:block; }

      /* 見ている商品（商品ページの「AIに質問する」から開いた時だけ表示） */
      #ai-ctx{
        grid-row:2; display:flex; align-items:center; gap:10px;
        padding:8px 10px 8px 12px; background:#fff; border-bottom:1px solid #e3e8e5;
      }
      #ai-ctx[hidden]{ display:none; }
      .ai-ctx-img{
        width:40px; height:40px; flex-shrink:0; border-radius:8px; background:#f4f5f6;
        object-fit:contain; display:block;
      }
      .ai-ctx-img[hidden]{ display:none; }
      .ai-ctx-text{ flex:1; min-width:0; }
      .ai-ctx-label{
        display:block; font-size:11px; font-weight:700; line-height:1.35; color:#07883d;
      }
      .ai-ctx-title{
        display:block; margin-top:1px; font-size:13px; font-weight:700; line-height:1.4; color:#1f2937;
        white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
      }
      /* 商品の相談 → その他のご相談へ */
      #ai-panel .ai-ctx-other{
        flex-shrink:0; margin:0; min-width:0; min-height:0; height:32px; padding:0 10px 0 12px;
        border:1px solid #cfe3d7; border-radius:999px; background:#fff; box-shadow:none;
        color:#07883d; font-size:12px; font-weight:700; line-height:1; white-space:nowrap;
        display:flex; align-items:center; gap:3px; cursor:pointer; transition:background .15s ease;
      }
      #ai-panel .ai-ctx-other:hover{ background:#f0f8f3; }
      #ai-panel .ai-ctx-other:focus-visible{ outline:2px solid var(--ai-brand); outline-offset:2px; }
      #ai-panel .ai-ctx-other svg, #ai-panel #ai-back .ai-back-arw svg{ width:14px; height:14px; display:block; }
      /* その他のご相談 → この商品の質問に戻る */
      #ai-panel #ai-back{
        grid-row:2; display:flex; align-items:center; gap:8px; width:100%; height:44px;
        margin:0; padding:0 12px 0 8px; min-width:0; min-height:0;
        border:none; border-bottom:1px solid #e3e8e5; border-radius:0; background:#fff; box-shadow:none;
        color:#07883d; font-size:12.5px; font-weight:700; line-height:1.3; text-align:left; cursor:pointer;
      }
      #ai-panel #ai-back[hidden]{ display:none; }
      #ai-panel #ai-back:hover{ background:#f6f9f7; }
      #ai-panel #ai-back:focus-visible{ outline:2px solid var(--ai-brand); outline-offset:-2px; }
      #ai-back .ai-back-img{ width:26px; height:26px; flex-shrink:0; border-radius:6px; background:#f4f5f6; object-fit:contain; display:block; }
      #ai-back .ai-back-img[hidden]{ display:none; }
      #ai-back .ai-back-lbl{ flex:1; min-width:0; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
      #ai-back .ai-back-now{ flex-shrink:0; font-size:11.5px; font-weight:600; color:#6b7280; }

      @media (max-width:600px){
        #ai-head{ padding:0 4px 0 12px; gap:9px; }
        .ai-head-av{ width:34px; height:34px; }
        .ai-head-av svg{ width:22px; height:22px; }
        .ai-title{ font-size:14.5px; }
        #ai-panel .ai-icon-btn{ width:44px; height:44px; }
        #ai-panel .ai-icon-btn svg{ width:22px; height:22px; }
        #ai-panel .ai-ctx-other{ height:36px; }
      }

      /* ログ */
      #ai-log{
        grid-row:3; position:relative; min-height:0;
        overflow-y:auto; overflow-x:hidden;
        -webkit-overflow-scrolling:touch;
        overscroll-behavior:contain;
        padding:14px 12px 6px; font-size:14px; line-height:1.7;
        background:#eef3f0;
      }
      #ai-log[data-empty="1"]{
        background:
          url('https://cdn.shopify.com/s/files/1/0772/5681/8928/files/syagami.png?v=1767099926') center 35% / 140px no-repeat,
          #eef3f0;
      }
      #ai-log::before{
        content:attr(data-placeholder);
        position:absolute; left:50%; top:80%; transform:translate(-50%,-50%);
        font-size:13px; color:#8a948f; pointer-events:none; display:none;
      }
      #ai-log[data-empty="1"]::before{ display:block; }
      #ai-log .ai-spacer{ height:1px; visibility:hidden; }

      @media (max-width:600px){
        #ai-log{
          padding:12px 10px 6px;
          font-size:13.5px;
        }
        #ai-log[data-empty="1"]{
          background:
            url('https://cdn.shopify.com/s/files/1/0772/5681/8928/files/syagami.png?v=1767099926') center 30% / 100px no-repeat,
            #eef3f0;
        }
        #ai-log::before{
          top:60%;
          font-size:12px;
        }
      }

      /* 質問チップ */
      #ai-chips{
        grid-row:4; display:flex; gap:6px; padding:4px 12px 8px;
        overflow-x:auto; overflow-y:hidden; scrollbar-width:none; background:#eef3f0;
      }
      #ai-chips::-webkit-scrollbar{ display:none; }
      #ai-panel .ai-chip{
        flex-shrink:0; white-space:nowrap; margin:0; min-height:0;
        font-family:inherit; font-size:12.5px; font-weight:600; line-height:1.2; letter-spacing:0;
        padding:7px 12px; border-radius:999px; box-shadow:none;
        background:#fff; color:#047a34; border:1px solid #bfe9cf;
        cursor:pointer; transition:background .15s ease, border-color .15s ease;
      }
      #ai-panel .ai-chip:hover{ background:#e8f9ef; border-color:#8fd8ab; }
      #ai-panel .ai-chip:focus-visible{ outline:2px solid var(--ai-brand); outline-offset:1px; }
      #ai-panel .ai-chip:disabled{ opacity:.5; cursor:default; }
      #ai-panel a.ai-chip{ display:inline-flex; align-items:center; text-decoration:none; }
      #ai-panel .ai-chip--diag{ background:var(--ai-brand); color:#fff; border-color:var(--ai-brand); }
      #ai-panel .ai-chip--diag:hover{ background:var(--ai-brand-hover); border-color:var(--ai-brand-hover); color:#fff; }

      /* 入力エリア */
      #ai-input-row{
        grid-row:5; padding:10px 12px 8px; background:#fff; border-top:1px solid #e3e8e5;
      }
      .ai-field{
        display:flex; align-items:flex-end; gap:8px;
        background:#f2f4f3; border:1.5px solid transparent; border-radius:22px;
        padding:4px 4px 4px 16px; transition:border-color .15s ease, background .15s ease;
      }
      .ai-field:focus-within{ background:#fff; border-color:var(--ai-brand); }
      #ai-panel #ai-input{
        flex:1; min-width:0; margin:0; padding:7px 0;
        border:none; outline:none; box-shadow:none; background:transparent; border-radius:0;
        font-family:inherit; font-size:14px; line-height:22px; color:var(--ai-text);
        resize:none; min-height:36px; max-height:140px; overflow-y:auto; white-space:pre-wrap;
      }
      #ai-panel #ai-input::placeholder{ color:#9aa39e; opacity:1; }
      #ai-panel #ai-send{
        width:36px; height:36px; min-width:36px; min-height:0; margin:0; padding:0;
        border:none; border-radius:50%; background:var(--ai-brand); color:#fff; box-shadow:none;
        display:flex; align-items:center; justify-content:center; flex-shrink:0;
        cursor:pointer; transition:background .15s ease, opacity .15s ease;
      }
      #ai-panel #ai-send svg{ width:18px; height:18px; margin-left:2px; display:block; fill:currentColor; }
      #ai-panel #ai-send:hover{ background:var(--ai-brand-hover); }
      #ai-panel #ai-send.is-empty{ background:#c5cfc9; cursor:default; }
      #ai-panel #ai-send:disabled{ opacity:.6; cursor:default; }
      #ai-panel #ai-send:focus-visible{ outline:2px solid var(--ai-brand); outline-offset:2px; }
      .ai-note{
        display:flex; justify-content:space-between; align-items:center; gap:8px;
        margin-top:6px; padding:0 6px; font-size:10.5px; line-height:1.45; color:#8a948f;
      }
      .ai-keys{ white-space:nowrap; flex-shrink:0; }
      .ai-note kbd{
        font-family:inherit; font-size:10px; line-height:1.4; padding:0 5px; border-radius:4px;
        background:#f2f4f3; color:#5f6b66; border:1px solid #e3e8e5; box-shadow:none;
      }

      @media (max-width:600px){
        #ai-chips{ padding:4px 10px 8px; }
        #ai-input-row{
          padding:8px 10px;
          padding-bottom:max(8px, env(safe-area-inset-bottom));
        }
        #ai-panel #ai-input{
          font-size:16px; /* iOS zoom防止 */
          padding:8px 0;
          min-height:38px;
        }
        #ai-panel #ai-send{ width:38px; height:38px; min-width:38px; }
        .ai-keys{ display:none; }
        .ai-note{ justify-content:center; }
      }

      /* メッセージ */
      .ai-msg{ display:flex; align-items:flex-start; gap:8px; margin:0 0 12px; }
      .ai-left{ justify-content:flex-start } .ai-right{ justify-content:flex-end }
      .ai-avatar{
        width:28px; height:28px; border-radius:50%; background:var(--ai-brand);
        display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:2px;
      }
      .ai-avatar svg{ width:17px; height:17px; fill:#fff; display:block; }
      .ai-inner{ max-width:80%; min-width:0; display:flex; flex-direction:column; align-items:flex-start; }
      .ai-right .ai-inner{ align-items:flex-end; }
      .ai-bubble{ position:relative; padding:10px 13px; border-radius:16px; word-break:break-word; white-space:pre-wrap; }
      .ai-left .ai-bubble{ background:#fff; color:var(--ai-text); border-top-left-radius:6px; box-shadow:0 1px 2px rgba(0,0,0,.06); }
      .ai-right .ai-bubble{ background:var(--ai-brand); color:#fff; border-top-right-radius:6px; }
      .ai-time{ margin:3px 4px 0; font-size:10.5px; color:#8a948f; }

      @media (max-width:600px){
        .ai-msg{ margin:0 0 10px; }
        .ai-inner{ max-width:84%; }
        .ai-bubble{ padding:9px 12px; font-size:13.5px; }
        .ai-time{ font-size:10px; }
      }

      /* タイピングアニメ */
      .ai-typing{
        background:#fff; border:1px solid #e6ebf3; border-radius:16px;
        padding:8px 10px; display:inline-flex; gap:6px; align-items:center;
        box-shadow:0 2px 6px rgba(0,0,0,.06);
      }
      .ai-typing i{ width:6px; height:6px; border-radius:50%; background:#a8b3c2; display:inline-block; animation:blink 1.2s infinite ease-in-out; }
      .ai-typing i:nth-child(2){ animation-delay:.15s; }
      .ai-typing i:nth-child(3){ animation-delay:.30s; }
      @keyframes blink{ 0%,80%,100%{opacity:.3; transform:translateY(0);} 40%{opacity:1; transform:translateY(-2px);} }

      /* ===== おすすめ商品カード（横スクロール） ===== */
      .ai-inner:has(.b-wrap){ max-width:calc(100% - 36px); }
      .b-wrap{ width:100%; margin-top:8px; }
      .b-view{ position:relative; }
      .b-track{ display:flex; gap:10px; overflow-x:auto; scroll-snap-type:x mandatory; padding:2px 2px 6px; -webkit-overflow-scrolling:touch; scrollbar-width:none; overscroll-behavior-x:contain; }
      .b-track::-webkit-scrollbar{ display:none; }
      .b-track.can-drag{ cursor:grab; }
      .b-track.is-drag{ cursor:grabbing; scroll-snap-type:none; user-select:none; -webkit-user-select:none; }
      .b-track.is-drag a{ pointer-events:none; }
      .b-track img{ -webkit-user-drag:none; user-select:none; }
      .b-pager{ display:flex; align-items:center; justify-content:center; gap:12px; margin-top:6px; }
      .b-pager[hidden]{ display:none; }
      .b-pager .b-dots{ margin-top:0; }
      .b-nav{ flex:none; width:30px; height:30px; border-radius:50%; border:1px solid #dfe5e1; background:#fff; color:#1f2723; box-shadow:0 1px 3px rgba(0,0,0,.08); display:flex; align-items:center; justify-content:center; cursor:pointer; padding:0; transition:opacity .15s, background .15s, border-color .15s; }
      .b-nav:not(:disabled):hover{ border-color:#06C755; color:#047a34; background:#f3fbf6; }
      .b-nav:focus-visible{ outline:2px solid #047a34; outline-offset:2px; }
      .b-nav:disabled{ opacity:.35; cursor:default; box-shadow:none; }
      .b-nav svg{ width:15px; height:15px; }
      .b-dots button{ width:6px; height:6px; border-radius:3px; background:#cfd6d2; border:0; padding:0; cursor:pointer; transition:width .2s, background .2s; }
      .b-dots button.on{ width:16px; background:#06C755; }
      .b-card{ flex:0 0 212px; scroll-snap-align:start; background:#fff; border:1px solid #e3e8e5; border-radius:14px; overflow:hidden; display:flex; flex-direction:column; box-shadow:0 1px 3px rgba(0,0,0,.06); }
      .b-img{ position:relative; height:150px; background:#f4f6f5; display:flex; align-items:center; justify-content:center; }
      .b-img img{ max-width:100%; max-height:100%; object-fit:contain; display:block; }
      .b-tag{ position:absolute; top:8px; left:8px; font-size:12px; font-weight:700; line-height:1; padding:5px 9px; border-radius:999px; }
      .b-tag.t1{ background:#e8f9ef; color:#047a34; }
      .b-tag.t2{ background:#fff3e6; color:#b45309; }
      .b-tag.t3{ background:#eef2ff; color:#4338ca; }
      .b-body{ padding:10px 12px 12px; display:flex; flex-direction:column; gap:8px; flex:1; }
      .b-gpu{ font-size:15px; font-weight:700; color:#111827; line-height:1.35; }
      .b-spec{ margin:0; display:grid; grid-template-columns:auto 1fr; gap:3px 10px; font-size:13px; line-height:1.45; }
      .b-spec dt{ color:#6b7570; white-space:nowrap; }
      .b-spec dd{ margin:0; color:#1f2723; overflow-wrap:anywhere; }
      .b-price{ border-top:1px solid #edf0ee; padding-top:8px; font-size:13px; color:#4b5550; font-variant-numeric:tabular-nums; }
      .b-line{ display:flex; justify-content:space-between; gap:8px; line-height:1.5; }
      .b-total{ display:flex; justify-content:space-between; align-items:baseline; gap:8px; margin-top:4px; color:#111827; font-weight:700; }
      .b-total strong{ font-size:18px; }
      .b-note{ font-size:12px; color:#8a948f; }
      .b-btn{ margin-top:auto; display:block; text-align:center; background:#06C755; color:#fff !important; font-weight:700; font-size:14px; padding:10px; border-radius:10px; text-decoration:none !important; }
      .b-btn:hover{ background:#05b04b; }
      .b-btn:focus-visible, .b-more:focus-visible{ outline:2px solid #047a34; outline-offset:2px; }
      .b-dots{ display:flex; justify-content:center; gap:5px; margin-top:2px; }
      .b-dots i{ width:6px; height:6px; border-radius:3px; background:#cfd6d2; transition:width .2s, background .2s; }
      .b-dots i.on{ width:16px; background:#06C755; }
      @media (prefers-reduced-motion: reduce){ .b-dots i, .b-dots button, .b-nav{ transition:none; } }

      /* ===== AI返信内リンクボタン ===== */
      /* あいさつの案内一覧と同じ、白地＋細い枠＋線のアイコン＋右の › で揃える */
      .ai-link-btn{
        display:inline-flex; align-items:center; gap:10px; vertical-align:middle;
        width:100%; max-width:280px; box-sizing:border-box;
        margin:6px 0 4px; padding:10px 12px;
        background:#fff;
        color:#1a1a1a !important;
        text-decoration:none !important;
        border:1px solid #e1e7e3; border-radius:10px;
        font-size:13px; font-weight:700; line-height:1.3;
        transition:background .15s ease;
      }
      .ai-link-btn:hover{ background:#f6f9f7; }
      .ai-link-btn:focus-visible{ outline:2px solid #06C755; outline-offset:2px; }
      .ai-link-btn .ai-link-ico{
        width:20px; height:20px; flex:0 0 20px;
        color:#0a8f43;
        display:inline-flex; align-items:center; justify-content:center;
      }
      .ai-link-btn .ai-link-ico svg{ width:18px; height:18px; display:block; }
      .ai-link-btn .ai-link-lbl{ flex:1; min-width:0; }
      .ai-link-btn .ai-link-go{ color:#b5bdb8; font-size:18px; line-height:1; flex-shrink:0; }

      /* 最初のあいさつの案内一覧 */
      .ai-greet-list{ margin:10px 0 0; border:1px solid #e1e7e3; border-radius:10px; overflow:hidden; background:#fff; }
      .ai-greet-item{
        display:flex; align-items:center; gap:10px; padding:11px 12px;
        color:#1a1a1a !important; text-decoration:none !important; transition:background .15s ease;
      }
      .ai-greet-item + .ai-greet-item{ border-top:1px solid #edf1ee; }
      .ai-greet-item:hover{ background:#f6f9f7; }
      .ai-greet-item:focus-visible{ outline:2px solid #06C755; outline-offset:-2px; }
      .ai-greet-ico{ width:20px; height:20px; flex:0 0 20px; color:#0a8f43; display:flex; align-items:center; justify-content:center; }
      .ai-greet-ico svg{ width:20px; height:20px; display:block; }
      .ai-greet-txt{ flex:1; min-width:0; }
      .ai-greet-ttl{ display:block; font-size:13px; font-weight:700; line-height:1.4; }
      .ai-greet-sub{ display:block; margin-top:1px; font-size:11.5px; line-height:1.45; color:#6b7280; }
      .ai-greet-go{ color:#b5bdb8; font-size:18px; line-height:1; flex-shrink:0; }
    `;
    document.head.appendChild(style);

    // ====== HTML挿入 ======
    // #ai-bubble が既に存在する場合（Liquid から出力済み）はそれを使う
    // 存在しない場合のみ JS で作成
    let aiBubbleEl = document.getElementById('ai-bubble');
    if (!aiBubbleEl) {
      aiBubbleEl = document.createElement('div');
      aiBubbleEl.id = 'ai-bubble';
      aiBubbleEl.setAttribute('aria-label', 'AI で相談');
      aiBubbleEl.setAttribute('title', 'AI で相談');
      aiBubbleEl.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M4 4h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-5 5v-5H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg><span class="ai-bubble-text">AI で相談</span>';
      document.body.appendChild(aiBubbleEl);
    }

    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div id="ai-hint">AI で相談</div>

      <div id="ai-panel" role="dialog" aria-modal="false" aria-label="TITAN AI相談">
        <div id="ai-head">
          <span class="ai-head-av" aria-hidden="true">${AGENT_SVG}</span>
          <div class="ai-head-text">
            <span class="ai-title">TITAN AI相談</span>
            <span class="ai-sub">AIがすぐにお答えします</span>
          </div>
          <button type="button" class="ai-icon-btn" id="ai-clear" title="会話を消去" aria-label="会話を消去">${TRASH_SVG}</button>
          <button type="button" class="ai-icon-btn" id="ai-close" title="閉じる" aria-label="AI相談を閉じる">${CLOSE_SVG}</button>
        </div>

        <div id="ai-ctx" hidden>
          <img class="ai-ctx-img" alt="" hidden>
          <div class="ai-ctx-text">
            <span class="ai-ctx-label">この商品について質問中</span>
            <span class="ai-ctx-title"></span>
          </div>
          <button type="button" class="ai-ctx-other">商品以外の相談${CHEV_R_SVG}</button>
        </div>

        <button type="button" id="ai-back" hidden>
          <span class="ai-back-arw" aria-hidden="true">${CHEV_L_SVG}</span>
          <img class="ai-back-img" alt="" hidden>
          <span class="ai-back-lbl">この商品の質問に戻る</span>
          <span class="ai-back-now">その他のご相談中</span>
        </button>

        <div id="ai-log" aria-live="polite" aria-relevant="additions"
             data-empty="1" data-placeholder="会話はまだありません、寂しい..."></div>

        <div id="ai-chips" role="group" aria-label="よくある質問">
          ${chipsHtml(false)}
        </div>

        <div id="ai-input-row">
          <div class="ai-field">
            <textarea id="ai-input" rows="1" placeholder="メッセージを入力" aria-label="メッセージを入力" enterkeyhint="send" autocomplete="off"></textarea>
            <button type="button" id="ai-send" class="is-empty" title="送信" aria-label="送信">${SEND_SVG}</button>
          </div>
          <div class="ai-note">
            <span>AIの回答は誤りを含むことがあります</span>
            <span class="ai-keys"><kbd>Enter</kbd> 送信 / <kbd>Shift</kbd>+<kbd>Enter</kbd> 改行</span>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    // ====== ユーティリティ ======
    const qs = (id) => document.getElementById(id);
    const isMobile = () => window.innerWidth <= 600;

    // ====== 商品ページからの質問：見ている商品の情報をAIへ渡す ======
    const DEFAULT_PLACEHOLDER = "メッセージを入力";
    const PRODUCT_PLACEHOLDER = "この商品について質問を入力";
    const productHandle = () => {
      const m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (!m) return "";
      try { return decodeURIComponent(m[1]); } catch (_) { return m[1]; }
    };
    const clip = (s, n) => String(s || "").replace(/\s+/g, " ").trim().slice(0, n);
    // 送信のたびに読み直す（オプション変更で商品名・価格・構成が変わるため）
    // ページに表示中の変更先と差額（CPUなどの条件で隠れているグループは除く）。送信時だけ読む
    function readPageChoices(app){
      const choices = [];
      if (!app) return choices;
      const seen = new Set();
      const hidden = (el) => {
        for (let n = el; n && n !== app; n = n.parentElement) {
          if (getComputedStyle(n).display === "none") return true;
        }
        return false;
      };
      app.querySelectorAll(".gpo-element").forEach(g => {
        if (choices.length >= 20 || g.querySelector(".gpo-element") || hidden(g)) return;
        const inputs = [...g.querySelectorAll("input[type=radio][name], input[type=checkbox][name]")];
        if (!inputs.length) return;
        const name = clip(inputs[0].name, 30);
        if (!name || seen.has(name)) return;
        if (inputs.length < 2 && inputs[0].type !== "checkbox") return;
        const items = inputs.filter(inp => inp.name === inputs[0].name).map(inp => {
          const lab = inp.id ? g.querySelector('label[for="' + CSS.escape(inp.id) + '"]') : null;
          const txt = clip(lab ? lab.textContent : inp.value, 120);
          const m = txt.match(/([+＋\-−])\s*¥?\s*([\d,]+)\s*円?\s*$/);
          const fee = m ? "（" + (/[\-−]/.test(m[1]) ? "-" : "+") + m[2] + "円）" : "（追加料金なし）";
          return clip(inp.value, 60) + fee + (inp.checked ? "［選択中］" : "");
        });
        seen.add(name);
        choices.push(clip(name + ": " + items.join(" / "), 400));
      });
      return choices;
    }
    function readPageProduct(withChoices){
      const handle = productHandle();
      const h1 = document.querySelector("h1[data-titan-title]");
      if (!handle || !h1) return null;
      const t = h1.cloneNode(true);
      t.querySelectorAll(".visually-hidden").forEach(n => n.remove());
      const title = clip(t.textContent, 120);
      if (!title) return null;
      const main = document.querySelector(".titan-price-block .titan-price-main");
      const addon = document.querySelector(".titan-price-block [data-titan-addon]:not([hidden])");
      const price = clip((main ? main.textContent : "") + (addon ? " " + addon.textContent : ""), 60);
      const specs = [];
      document.querySelectorAll(".tg-spc__table tr").forEach(tr => {
        const cells = tr.querySelectorAll("th,td");
        if (cells.length < 2 || specs.length >= 12) return;
        const k = clip(cells[0].textContent, 20), v = clip(cells[cells.length - 1].textContent, 80);
        if (k && v) specs.push(k + ": " + v);
      });
      const options = [];
      const seen = new Set();
      const app = document.querySelector(".gpo-app");
      if (app) {
        app.querySelectorAll("select[name], input[type=radio][name]:checked, input[type=checkbox][name]:checked").forEach(el => {
          const name = clip(el.name, 30);
          if (!name || seen.has(name) || options.length >= 16) return;
          let v = "";
          if (el.tagName === "SELECT") { const o = el.options[el.selectedIndex]; v = o ? o.text : ""; }
          else v = el.value;
          v = clip(v, 80);
          if (!v) return;
          seen.add(name);
          options.push(name + ": " + v);
        });
      }
      const og = document.querySelector('meta[property="og:image"]');
      const shipEl = document.querySelector("[data-tg-ship-text]");
      const etaEl = document.querySelector("[data-tg-eta]:not([hidden])");
      const delivery = clip([shipEl ? shipEl.textContent : "", etaEl ? etaEl.textContent : ""].map(s => clip(s, 60)).filter(Boolean).join(" / "), 120);
      const out = { handle, title, price, specs, options, delivery, image: og ? og.content : "" };
      if (withChoices) out.choices = readPageChoices(app);
      return out;
    }
    let pageCtxOn = false;
    function renderPageCtx(){
      const bar = qs("ai-ctx"), input = qs("ai-input");
      const p = pageCtxOn ? readPageProduct() : null;
      if (!p) pageCtxOn = false;
      if (bar) {
        bar.hidden = !pageCtxOn;
        if (p) {
          bar.querySelector(".ai-ctx-title").textContent = p.title;
          const img = bar.querySelector(".ai-ctx-img");
          const src = p.image ? p.image.replace(/([?&])width=\d+/, "$1width=120") : "";
          if (src && img.getAttribute("src") !== src) img.setAttribute("src", src);
          img.hidden = !src;
        }
      }
      // その他のご相談中でも、商品ページならいつでも商品の質問に戻れるようにする
      const back = qs("ai-back");
      if (back) {
        const bp = !pageCtxOn && productHandle() ? readPageProduct() : null;
        back.hidden = !bp;
        if (bp) {
          const bimg = back.querySelector(".ai-back-img");
          const bsrc = bp.image ? bp.image.replace(/([?&])width=\d+/, "$1width=120") : "";
          if (bsrc && bimg.getAttribute("src") !== bsrc) bimg.setAttribute("src", bsrc);
          bimg.hidden = !bsrc;
          back.setAttribute("aria-label", bp.title + " の質問に戻る");
        }
      }
      if (input && !input.disabled) input.placeholder = pageCtxOn ? PRODUCT_PLACEHOLDER : DEFAULT_PLACEHOLDER;
      syncGreeting(false);
    }
    // 商品ページでは左下ボタンから開いても商品の相談にする。「商品以外の相談」を選んだ商品だけはこのタブではその他のご相談のまま
    function pageCtxDismissed(){
      try { return sessionStorage.getItem(PCTX_OFF_KEY) === productHandle(); } catch (_) { return false; }
    }
    function autoPageCtx(){
      if (pageCtxOn || !productHandle() || pageCtxDismissed()) return;
      if (readPageProduct()) switchMode(true);
    }
    // quiet: 自動で付けたときは会話の途中に案内を足さない（上の商品表示だけ出す）
    function setPageCtx(on, quiet){
      pageCtxOn = !!on && !!readPageProduct();
      try {
        if (pageCtxOn) { sessionStorage.setItem(PCTX_KEY, productHandle()); sessionStorage.removeItem(PCTX_OFF_KEY); }
        else sessionStorage.removeItem(PCTX_KEY);
      } catch (_) {}
      renderPageCtx();
      syncGreeting(pageCtxOn && !quiet);
      try { refreshChips(); } catch (_) {}
    }
    // 商品の相談 ⇄ その他のご相談。履歴は別々なので、ログを描き直す
    function switchMode(on){
      if (sending || !productHandle()) return false;
      try {
        if (on) sessionStorage.removeItem(PCTX_OFF_KEY);
        else sessionStorage.setItem(PCTX_OFF_KEY, productHandle());
      } catch (_) {}
      setPageCtx(on, true);
      const log = qs("ai-log");
      if (!log) return true;
      log.querySelectorAll(".ai-msg").forEach(n => n.remove());
      greetingEl = null;
      loadHistory();
      if (!log.querySelector(".ai-msg")) appendGreeting();
      log.scrollTop = log.scrollHeight;
      return true;
    }

    // 最初のあいさつ。商品ページの「AIに質問する」から開いたときは、その商品についての案内にする
    const DIAG_URL = "/pages/%E3%82%B2%E3%83%BC%E3%83%A0%E3%81%8B%E3%82%89%E9%81%B8%E3%81%B6";
    const DEFAULT_GREETING_HTML = '<div style="font-size:14px;line-height:1.6;">こんにちは！PC選びのお手伝いをします。</div>' +
      '<div class="ai-greet-list">' +
        '<a class="ai-greet-item" href="' + DIAG_URL + '">' +
          '<span class="ai-greet-ico">' + PC_LINE_SVG + '</span>' +
          '<span class="ai-greet-txt"><span class="ai-greet-ttl">AIゲーミングPC診断</span><span class="ai-greet-sub">予算や用途からAIがぴったりの1台を提案</span></span>' +
          '<span class="ai-greet-go" aria-hidden="true">›</span>' +
        '</a>' +
        '<a class="ai-greet-item" href="/pages/%E3%82%88%E3%81%8F%E3%81%82%E3%82%8B%E8%B3%AA%E5%95%8F">' +
          '<span class="ai-greet-ico">' + FAQ_LINE_SVG + '</span>' +
          '<span class="ai-greet-txt"><span class="ai-greet-ttl">よくある質問</span><span class="ai-greet-sub">納期・保証・支払い方法など</span></span>' +
          '<span class="ai-greet-go" aria-hidden="true">›</span>' +
        '</a>' +
      '</div>' +
      '<div style="margin-top:10px;font-size:13px;line-height:1.5;">他に聞きたいことがあればお気軽にどうぞ！</div>';
    let greetingEl = null;
    function fillGreeting(el){
      const p = pageCtxOn ? readPageProduct() : null;
      const mode = p ? "product:" + p.title : "default";
      if (el.getAttribute("data-greet") === mode) return;
      el.setAttribute("data-greet", mode);
      if (!p) { el.innerHTML = DEFAULT_GREETING_HTML; return; }
      el.innerHTML = '<div style="font-size:14px;line-height:1.6;"><span class="ai-greet-title" style="font-weight:700;"></span>についてお答えします。</div>' +
        '<div style="margin-top:6px;font-size:13px;line-height:1.6;color:#444;">構成や遊べるゲーム、カスタマイズ、納期など、気になることをそのまま送ってください。保証・支払いなど商品以外のご相談は、上の「商品以外の相談」からどうぞ。</div>' +
        '<a href="' + DIAG_URL + '" style="display:inline-block;margin-top:10px;font-size:12px;font-weight:700;color:#0a8f43;text-decoration:underline;text-underline-offset:3px;">ほかのPCと比べるなら AIゲーミングPC診断 ›</a>';
      el.querySelector(".ai-greet-title").textContent = p.title;
    }
    function appendGreeting(){
      const g = document.createElement("div");
      g.className = "ai-bubble";
      g.style.cssText = "white-space:normal;padding:12px 14px;";
      greetingEl = g;
      fillGreeting(g);
      appendMsg("assistant", g);
    }
    // allowAppend: 会話の途中で商品の話題に切り替えたとき、案内を1つだけ足す（保存はしない）
    function syncGreeting(allowAppend){
      if (greetingEl && greetingEl.isConnected) { fillGreeting(greetingEl); return; }
      if (!allowAppend || !pageCtxOn) return;
      const log = qs("ai-log");
      if (!log) return;
      const msgs = log.querySelectorAll(".ai-msg");
      if (!msgs.length) return;
      const last = msgs[msgs.length - 1].querySelector("[data-greet]");
      const p = readPageProduct();
      if (!p || (last && last.getAttribute("data-greet") === "product:" + p.title)) return;
      const g = document.createElement("div");
      g.className = "ai-bubble";
      g.style.cssText = "white-space:normal;padding:12px 14px;";
      fillGreeting(g);
      appendMsg("assistant", g);
    }

    const nowTime = () => {
      const d = new Date();
      return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    };
    const bubble = (t) => {
      const el = document.createElement("div");
      el.className = "ai-bubble";
      el.textContent = t;
      return el;
    };

    // ▼ AI返信用: 平文テキスト内のURLを検出してボタン化
    // - XSS対策: テキストは textContent で挿入、URLのみ createElement('a')
    // - titan-pc.net 以外のリンクも一律ボタン化（ただしラベル違い）
    const URL_RE = /(https?:\/\/[^\s、。　<>"'`]+)/g;
    // インラインSVG (Heroicons / Feather風の線画アイコン、stroke=currentColor)
    const SVG = {
      search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
      contact: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
      product: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2l-3 5v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7l-3-5z"/><path d="M3 7h18"/><path d="M16 11a4 4 0 0 1-8 0"/></svg>',
      doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>',
      external: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><path d="M10 14L21 3"/></svg>'
    };
    const linkButtonFor = (url) => {
      const trimmed = url.replace(/[.,、。;:!?)\]}]+$/, "");
      let kind = "other", svg = SVG.external, label = "リンクを開く";
      try {
        const u = new URL(trimmed);
        const host = u.hostname.replace(/^www\./, "");
        if (host === "titan-pc.net") {
          if (u.pathname.startsWith("/search") || u.pathname === "/search") {
            const q = u.searchParams.get("q") || "";
            kind = "search"; svg = SVG.search;
            label = q ? `${q} を探す` : "商品を探す";
          } else if (u.pathname.startsWith("/pages/contact")) {
            kind = "contact"; svg = SVG.contact; label = "お問い合わせ";
          } else if (u.pathname.startsWith("/products/")) {
            kind = "product"; svg = SVG.product; label = "商品を見る";
          } else if (u.pathname.startsWith("/policies/")) {
            kind = "other"; svg = SVG.doc; label = "ポリシー";
          } else {
            kind = "other"; svg = SVG.external; label = "詳細を見る";
          }
        }
      } catch (_) { /* URL parse fail → 既定値 */ }
      const a = document.createElement("a");
      a.className = `ai-link-btn ${kind}`;
      a.href = trimmed;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      const ico = document.createElement("span");
      ico.className = "ai-link-ico";
      ico.setAttribute("aria-hidden", "true");
      ico.innerHTML = svg; // 固定のSVG文字列のみ、ユーザー入力無し
      const lbl = document.createElement("span");
      lbl.className = "ai-link-lbl";
      lbl.textContent = label;
      const go = document.createElement("span");
      go.className = "ai-link-go";
      go.setAttribute("aria-hidden", "true");
      go.textContent = "›";
      a.appendChild(ico); a.appendChild(lbl); a.appendChild(go);
      return { node: a, url: trimmed };
    };
    const bubbleRich = (t) => {
      const el = document.createElement("div");
      el.className = "ai-bubble";
      if (typeof t !== "string" || !t) { el.textContent = t || ""; return el; }
      // URLを検出しつつ、前後テキストは textContent で安全に挿入
      let lastIdx = 0;
      const matches = [];
      let m;
      URL_RE.lastIndex = 0;
      while ((m = URL_RE.exec(t)) !== null) {
        matches.push({ idx: m.index, raw: m[0] });
      }
      if (matches.length === 0) { el.textContent = t; return el; }
      matches.forEach(({ idx, raw }) => {
        if (idx > lastIdx) {
          el.appendChild(document.createTextNode(t.slice(lastIdx, idx)));
        }
        const { node, url } = linkButtonFor(raw);
        el.appendChild(node);
        // URL文字列末尾で改行があれば保持するために lastIdx を進める
        lastIdx = idx + raw.length;
      });
      if (lastIdx < t.length) el.appendChild(document.createTextNode(t.slice(lastIdx)));
      return el;
    };
    const typingBubble = () => {
      const el = document.createElement("div");
      el.className = "ai-typing";
      el.innerHTML = "<i></i><i></i><i></i>";
      return el;
    };

    // ▼ おすすめ商品カード（リレーの products を横スクロールで表示）
    const yen = (n) => Number(n || 0).toLocaleString("ja-JP") + "円";
    const safeHttps = (u) => {
      try { const x = new URL(String(u || ""), location.origin); return x.protocol === "https:" ? x.href : ""; }
      catch (_) { return ""; }
    };
    const mk = (tag, cls, txt) => {
      const el = document.createElement(tag);
      if (cls) el.className = cls;
      if (txt != null) el.textContent = String(txt);
      return el;
    };
    const cleanProducts = (list) => (Array.isArray(list) ? list : [])
      .filter(p => p && typeof p === "object" && safeHttps(p.url))
      .slice(0, 3);
    function productCards(list){
      const items = cleanProducts(list);
      if (!items.length) return null;
      const wrap = mk("div", "b-wrap");
      const track = mk("div", "b-track");
      track.setAttribute("role", "list");
      track.setAttribute("aria-label", "おすすめのPC");
      items.forEach((p) => {
        const card = mk("article", "b-card");
        card.setAttribute("role", "listitem");
        const imgBox = mk("div", "b-img");
        const src = safeHttps(p.image);
        if (src) {
          const img = document.createElement("img");
          img.src = src; img.alt = [p.gpu, p.case].filter(Boolean).join(" "); img.loading = "lazy"; img.decoding = "async";
          img.width = 212; img.height = 150;
          imgBox.appendChild(img);
        }
        if (p.tag) imgBox.appendChild(mk("span", "b-tag t" + ([1, 2, 3].includes(Number(p.tone)) ? Number(p.tone) : 1), p.tag));
        card.appendChild(imgBox);

        const body = mk("div", "b-body");
        body.appendChild(mk("div", "b-gpu", p.gpu || "ゲーミングPC"));
        const dl = mk("dl", "b-spec");
        [["CPU", p.cpu], ["メモリ", p.memory], ["SSD", p.ssd], ["ケース", p.case]].forEach(([k, v]) => {
          if (!v) return;
          dl.appendChild(mk("dt", "", k)); dl.appendChild(mk("dd", "", v));
        });
        body.appendChild(dl);

        const price = mk("div", "b-price");
        const addons = Array.isArray(p.addons) ? p.addons.filter(a => a && a.label) : [];
        if (addons.length) {
          const base = mk("div", "b-line"); base.appendChild(mk("span", "", "本体")); base.appendChild(mk("span", "", yen(p.price))); price.appendChild(base);
          addons.forEach(a => { const l = mk("div", "b-line"); l.appendChild(mk("span", "", a.label)); l.appendChild(mk("span", "", "+" + yen(a.price))); price.appendChild(l); });
        }
        const total = mk("div", "b-total");
        total.appendChild(mk("span", "", addons.length ? "合計" : "価格"));
        total.appendChild(mk("strong", "", yen(p.total || p.price)));
        price.appendChild(total);
        if (addons.length) price.appendChild(mk("div", "b-note", "オプションは商品ページで選択してください"));
        body.appendChild(price);

        const btn = mk("a", "b-btn", "商品ページを見る");
        btn.href = safeHttps(p.url);
        body.appendChild(btn);
        card.appendChild(body);
        track.appendChild(card);
      });
      const view = mk("div", "b-view");
      view.appendChild(track);
      wrap.appendChild(view);
      if (items.length > 1) {
        const cardLeft = (i) => { const c = track.children[i]; return c ? c.offsetLeft - track.children[0].offsetLeft : 0; };
        const maxLeft = () => Math.max(0, track.scrollWidth - track.clientWidth);
        const currentIndex = () => {
          const cards = track.children;
          if (track.scrollLeft >= maxLeft() - 4) return cards.length - 1;
          let idx = 0, best = Infinity;
          for (let i = 0; i < cards.length; i++) { const d = Math.abs(cardLeft(i) - track.scrollLeft); if (d < best) { best = d; idx = i; } }
          return idx;
        };
        const goTo = (i) => {
          const n = Math.max(0, Math.min(track.children.length - 1, i));
          track.scrollTo({ left: Math.min(cardLeft(n), maxLeft()), behavior: "smooth" });
        };
        const arrow = (dir) => {
          const b = mk("button", "b-nav " + dir);
          b.type = "button";
          b.setAttribute("aria-label", dir === "prev" ? "前のPCを見る" : "次のPCを見る");
          b.innerHTML = dir === "prev"
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
          b.addEventListener("click", () => goTo(currentIndex() + (dir === "prev" ? -1 : 1)));
          return b;
        };
        const pager = mk("div", "b-pager");
        const prev = arrow("prev");
        const next = arrow("next");
        const dots = mk("div", "b-dots");
        dots.setAttribute("aria-hidden", "true");
        items.forEach((_, i) => {
          const d = document.createElement("button");
          d.type = "button"; d.tabIndex = -1;
          if (i === 0) d.className = "on";
          d.addEventListener("click", () => goTo(i));
          dots.appendChild(d);
        });
        pager.appendChild(prev);
        pager.appendChild(dots);
        pager.appendChild(next);
        wrap.appendChild(pager);
        const sync = () => {
          const idx = currentIndex();
          Array.from(dots.children).forEach((d, i) => { d.className = i === idx ? "on" : ""; });
          const scrollable = maxLeft() > 4;
          pager.hidden = !scrollable;
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= maxLeft() - 4;
          track.classList.toggle("can-drag", scrollable);
        };
        track.addEventListener("scroll", sync, { passive: true });
        if (typeof ResizeObserver === "function") new ResizeObserver(sync).observe(track);
        requestAnimationFrame(sync);

        // PCのマウス：つかんで横に動かす（指やペンはブラウザ標準のスクロールのまま）
        let drag = null, dragged = false;
        track.addEventListener("pointerdown", (e) => {
          if (e.pointerType !== "mouse" || e.button !== 0 || maxLeft() <= 4) return;
          drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft, start: currentIndex(), moved: false };
          dragged = false;
        });
        track.addEventListener("pointermove", (e) => {
          if (!drag || e.pointerId !== drag.id) return;
          const dx = e.clientX - drag.x;
          if (!drag.moved) {
            if (Math.abs(dx) < 6) return;
            drag.moved = true;
            track.classList.add("is-drag");
            try { track.setPointerCapture(e.pointerId); } catch (_) {}
            const sel = window.getSelection && window.getSelection();
            if (sel && sel.removeAllRanges) sel.removeAllRanges();
          }
          e.preventDefault();
          track.scrollLeft = drag.left - dx;
        });
        const endDrag = (e) => {
          if (!drag || (e && e.pointerId !== drag.id)) return;
          const moved = drag.moved, start = drag.start, delta = track.scrollLeft - drag.left;
          try { track.releasePointerCapture(drag.id); } catch (_) {}
          drag = null;
          if (!moved) return;
          dragged = true;
          track.classList.remove("is-drag");
          let target = currentIndex();
          if (delta > 40 && target <= start) target = start + 1;
          if (delta < -40 && target >= start) target = start - 1;
          goTo(target);
          setTimeout(() => { dragged = false; }, 0);
        };
        track.addEventListener("pointerup", endDrag);
        track.addEventListener("pointercancel", endDrag);
        track.addEventListener("click", (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
        track.addEventListener("dragstart", (e) => e.preventDefault());
      }
      return wrap;
    }
    // 返信本文＋カードをまとめたノード（DocumentFragment）
    function assistantNode(text, products){
      const frag = document.createDocumentFragment();
      frag.appendChild(bubbleRich(text));
      const cards = productCards(products);
      if (cards) frag.appendChild(cards);
      return frag;
    }

    // ▼ ヒント表示制御
    function hideHintFor24h() {
      const hint = qs("ai-hint");
      if (hint) hint.style.display = "none";
      try { localStorage.setItem(HINT_KEY, String(Date.now())); } catch (_) { /* storage unavailable */ }
    }
    function shouldShowHint() {
      let ts = 0;
      try { ts = Number(localStorage.getItem(HINT_KEY) || 0); } catch (_) { return false; }
      if (!ts) return true;
      return (Date.now() - ts) >= HINT_TTL;
    }
    if (!shouldShowHint()) {
      const hint = qs("ai-hint");
      if (hint) hint.style.display = "none";
    }

    function updateEmptyState(){
      const elLog = qs("ai-log");
      elLog.querySelectorAll(".ai-spacer").forEach(n => n.remove());
      const hasMsg = !!elLog.querySelector(".ai-msg");
      elLog.setAttribute("data-empty", hasMsg ? "0" : "1");
      const spacer = document.createElement("div"); spacer.className = "ai-spacer";
      elLog.appendChild(spacer);
    }

    function appendMsg(role, node){
      const elLog = qs("ai-log");
      const row = document.createElement("div"); row.className = "ai-msg " + (role==="user" ? "ai-right":"ai-left");
      const inner = document.createElement("div"); inner.className = "ai-inner";
      const time = document.createElement("div"); time.className = "ai-time"; time.textContent = nowTime();
      if (role !== "user") {
        const av = document.createElement("div");
        av.className = "ai-avatar";
        av.setAttribute("aria-hidden", "true");
        av.innerHTML = AGENT_SVG; // 固定SVGのみ
        row.appendChild(av);
      }
      inner.appendChild(node); inner.appendChild(time); row.appendChild(inner);
      elLog.appendChild(row); elLog.scrollTop = elLog.scrollHeight;
      updateEmptyState();
      return row;
    }

    // 履歴
    // 商品の相談は商品ごとに PSTORE_KEY、その他のご相談は STORAGE_KEY に保存する
    const histHandle = () => (pageCtxOn ? productHandle() : "");
    const keepFresh = (a) => { const cutoff = Date.now() - KEEP_MS; return Array.isArray(a) ? a.filter(m => m && (m.ts || 0) >= cutoff) : []; };
    function readProductStore(){
      try { const o = JSON.parse(localStorage.getItem(PSTORE_KEY) || "{}"); return o && typeof o === "object" && !Array.isArray(o) ? o : {}; }
      catch (_) { return {}; }
    }
    function histGet(){
      const h = histHandle();
      if (h) return keepFresh(readProductStore()[h]);
      try { return keepFresh(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]")); } catch (_) { return []; }
    }
    function histSet(arr){
      const h = histHandle();
      try {
        if (!h) {
          if (arr.length) localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
          else localStorage.removeItem(STORAGE_KEY);
          return;
        }
        const all = readProductStore();
        const rest = Object.keys(all).filter(k => k !== h)
          .map(k => [k, keepFresh(all[k])]).filter(([, a]) => a.length)
          .sort((x, y) => (y[1][y[1].length - 1].ts || 0) - (x[1][x[1].length - 1].ts || 0))
          .slice(0, 19);
        const out = {};
        if (arr.length) out[h] = arr;
        for (const [k, a] of rest) out[k] = a;
        if (Object.keys(out).length) localStorage.setItem(PSTORE_KEY, JSON.stringify(out));
        else localStorage.removeItem(PSTORE_KEY);
      } catch (_) {}
    }
    function loadHistory(){
      const arr = histGet();
      histSet(arr);
      for(const m of arr){ appendMsg(m.role, (m.role === "assistant" ? assistantNode(m.text, m.products) : bubble(m.text))); }
      refreshChips();
      updateEmptyState();
    }
    function saveMessage(role, text, products){
      let arr = histGet();
      const item = {role, text, ts: Date.now()};
      const cards = cleanProducts(products);
      if (cards.length) item.products = cards;
      arr.push(item);
      if(arr.length>500) arr = arr.slice(arr.length-500);
      histSet(arr);
    }
    // 最新のやり取りから候補チップを選び直す（履歴の読み込み・返信のたび）
    function refreshChips(){
      const box = qs("ai-chips");
      if (!box) return;
      const arr = histGet();
      let sug = suggestChips(arr);
      if (pageCtxOn) {
        // 商品ページから質問中は、その商品についての質問を先に出す（送った質問は外す）
        const said = new Set(arr.filter(m => m && m.role === "user").map(m => String(m.text || "").trim()));
        const left = PRODUCT_QUESTIONS.filter(c => !said.has(c.q)).slice(0, 3);
        if (left.length) sug = { list: left, diag: false };
      }
      const sig = sug.list.map(c => c.label).join("|") + (sug.diag ? "|diag" : "");
      if (box.getAttribute("data-sig") === sig) return;
      box.setAttribute("data-sig", sig);
      box.setAttribute("data-mode", arr.length || pageCtxOn ? "context" : "default");
      box.innerHTML = chipsHtml(sug.list, sug.diag);
      box.scrollLeft = 0;
      try { if (sending) setChipsDisabled(true); } catch(_) {}
    }

    function clearHistory(){
      const log = qs("ai-log");
      log.querySelectorAll(".ai-msg").forEach(n => n.remove());
      histSet([]);
      greetingEl = null;
      refreshChips();
      log.scrollTop = 0;
      updateEmptyState();
    }
    function getHistoryForServer(){
      return histGet().map(m => ({ role: m.role, content: m.text })).slice(-40);
    }

    // スパム
    function getGuard(){
      try{ return JSON.parse(localStorage.getItem(GUARD_KEY) || '{"events":[],"lastMsgs":[]}'); }
      catch(_){ return {events:[], lastMsgs:[]}; }
    }
    function setGuard(g){ localStorage.setItem(GUARD_KEY, JSON.stringify(g)); }
    function isBlocked(){
      const raw = localStorage.getItem(BLOCK_KEY);
      if(!raw) return false;
      try{
        const o = JSON.parse(raw);
        if(Date.now() - (o.ts||0) >= BLOCK_TTL){ localStorage.removeItem(BLOCK_KEY); return false; }
        return true;
      }catch(_){ localStorage.removeItem(BLOCK_KEY); return false; }
    }
    function setBlocked(v){ v ? localStorage.setItem(BLOCK_KEY, JSON.stringify({ ts: Date.now() })) : localStorage.removeItem(BLOCK_KEY); }
    function recordAndCheckSpam(msg){
      const now = Date.now();
      const g = getGuard();
      g.events = (g.events||[]).filter(t => now - t < SPAM_WINDOW);
      g.events.push(now);
      const MSG_WINDOW = 60*1000;
      g.lastMsgs = (g.lastMsgs||[]).filter(m => now - m.ts < MSG_WINDOW);
      g.lastMsgs.push({text: msg, ts: now});
      if (g.events.length > SPAM_LIMIT) { setGuard(g); return true; }
      if (g.lastMsgs.filter(m => m.text === msg).length >= REPEAT_LIMIT) { setGuard(g); return true; }
      setGuard(g); return false;
    }
    function resetGuard(){ localStorage.removeItem(GUARD_KEY); setBlocked(false); }

    // スクロール位置保存（モバイル用）
    let savedScrollY = 0;

    // Googleウィジェット表示/非表示
    // 注: 走査範囲は <body> 直下の固定/絶対配置要素に限定する。
    //     全DOM (`*`) を走査するとSVG等で `el.id` が文字列でない要素に当たり throw する。
    function setGoogleWidgetDisplay(displayValue) {
      try {
        document.querySelectorAll('iframe').forEach(function(iframe) {
          var src = typeof iframe.src === 'string' ? iframe.src : '';
          if (src.indexOf('merchant') !== -1) {
            iframe.style.setProperty('display', displayValue, 'important');
          }
        });
        document.querySelectorAll('[id*="merchant"], [class*="merchant"]').forEach(function(el) {
          el.style.setProperty('display', displayValue, 'important');
        });
      } catch (e) { /* no-op */ }
    }
    function hideGoogleWidget() { setGoogleWidgetDisplay('none'); }
    function showGoogleWidget() { setGoogleWidgetDisplay('block'); }

    function syncAiFabState(isOpen) {
      const fab = document.querySelector('.titan-ai-fab');
      if (!fab) return;
      fab.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      fab.setAttribute('aria-label', isOpen ? 'AI相談を閉じる' : 'AIに相談してゲーミングPCを選ぶ');
      fab.setAttribute('title', isOpen ? 'AI相談を閉じる' : 'AIに相談して選ぶ');
    }

    // UI 開閉
    // PCではパネルをAI丸ボタンの真上に置く。商品ページでは価格バーを避けてボタンが上がるため、
    // 固定の bottom:70px のままだとボタンがパネルに重なる。ボタンの実位置から毎回計算する。
    let fabObserver = null;
    function placePanel(){
      const panel = qs("ai-panel");
      if (!panel) return;
      if (isMobile()) { panel.style.bottom = ""; panel.style.maxHeight = ""; return; }
      const fab = document.querySelector('.titan-ai-fab');
      const r = fab ? fab.getBoundingClientRect() : null;
      if (!r || !r.height) { panel.style.bottom = ""; panel.style.maxHeight = ""; return; }
      const bottom = Math.max(70, Math.round(window.innerHeight - r.top + 6));
      panel.style.bottom = bottom + "px";
      panel.style.maxHeight = Math.max(320, window.innerHeight - bottom - 16) + "px";
    }
    function watchFab(on){
      if (fabObserver) { fabObserver.disconnect(); fabObserver = null; }
      window.removeEventListener('resize', placePanel);
      if (!on) return;
      window.addEventListener('resize', placePanel);
      const fab = document.querySelector('.titan-ai-fab');
      if (fab && window.MutationObserver) {
        fabObserver = new MutationObserver(placePanel);
        fabObserver.observe(fab, { attributes: true, attributeFilter: ['style', 'class'] });
      }
    }

    function showPanel(){
      const panel=qs("ai-panel"), hint=qs("ai-hint");

      clearTimeout(panelOutTimer);
      panel.classList.remove("is-anim-out");
      panel.classList.remove("is-anim-in");
      void panel.offsetWidth; // 閉じかけからの再表示でもアニメを最初から再生する
      panel.classList.add("is-anim-in");

      document.body.classList.add("ai-panel-open");
      panel.setAttribute('aria-modal', isMobile() ? 'true' : 'false');
      syncAiFabState(true);

      if (isMobile()) {
        savedScrollY = window.scrollY;
        document.body.style.top = `-${savedScrollY}px`;
        hideGoogleWidget();
      }

      panel.style.display="grid";
      placePanel();
      watchFab(true);
      autoPageCtx();
      renderPageCtx();
      if (hint) hideHintFor24h();

      setTimeout(() => {
        qs("ai-log").scrollTop = qs("ai-log").scrollHeight;
        if (!isMobile()) {
          qs("ai-input").focus();
        }
      }, 100);
    }

    function hidePanel(){
      const panel = qs("ai-panel");
      if (panel.classList.contains("is-anim-out")) return;
      const closeHadFocus = document.activeElement === qs("ai-close");
      const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const finish = function(){
        clearTimeout(panelOutTimer);
        panel.classList.remove("is-anim-out");
        panel.classList.remove("is-anim-in");
        finishHide(panel, closeHadFocus);
      };
      if (reduce || panel.style.display !== "grid") { finish(); return; }
      panel.classList.add("is-anim-out");
      panelOutTimer = setTimeout(finish, 200);
    }
    var panelOutTimer = null;

    function finishHide(panel, closeHadFocus){
      panel.style.display="none";
      watchFab(false);

      document.body.classList.remove("ai-panel-open");
      syncAiFabState(false);

      if (isMobile()) {
        document.body.style.top = "";
        window.scrollTo(0, savedScrollY);
        showGoogleWidget();
      }

      if (closeHadFocus) {
        const fab = document.querySelector('.titan-ai-fab');
        if (fab) setTimeout(() => fab.focus(), 0);
      }
    }

    // 返信表示＋保存 (v: URLボタン化対応)
    function renderAndSaveAssistant(typingRow, text, products){
      const inner = typingRow.querySelector(".ai-inner");
      inner.replaceChild(assistantNode(text, products), inner.firstChild);
      try{ saveMessage("assistant", text, products); }catch(_){}
      const log = qs("ai-log");
      refreshChips();
      if (log && inner.querySelector(".b-wrap")) {
        // カード付きの返信は、返信の先頭が見える位置までスクロール
        log.scrollTop += typingRow.getBoundingClientRect().top - log.getBoundingClientRect().top - 8;
      }
    }

    // 送信
    let sessionId = localStorage.getItem(SESSION_KEY);
    if(!sessionId){
      sessionId = "s_" + Math.random().toString(36).slice(2) + Date.now();
      localStorage.setItem(SESSION_KEY, sessionId);
    }
    let sending = false;
    let lastSendTime = 0;

    async function sendBase(msg, retryCount = 0, typingRow = null){
      if (msg === UNLOCK_CODE) {
        resetGuard();
        // 診断側のクライアント制限もクリア
        try {
          localStorage.removeItem('wz_diag_hour_v1');
          localStorage.removeItem('wz_guard_v1');
          localStorage.removeItem('wz_blocked_v1');
          // 診断UI残り回数表示も更新
          var diagEl = document.getElementById('wzDiagRemain');
          if (diagEl) {
            diagEl.textContent = '残り10回';
            diagEl.className = 'wz-diag-remain';
          }
        } catch(_){}
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "制限を解除しました！チャット・診断どちらも回数がリセットされました✨");
        return { done: true };
      }
      if (isBlocked()) {
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "スパムと検知されました、数日後に再度お試しください。");
        return { done: true };
      }
      const now = Date.now();
      if (retryCount === 0 && (now - lastSendTime < RATE_MS)) {
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "少し待ってから送信してください💢");
        return { done: true };
      }
      if (retryCount === 0 && recordAndCheckSpam(msg)) {
        setBlocked(true);
        if (!typingRow){
          const typing = typingBubble();
          typingRow = appendMsg("assistant", typing);
        }
        renderAndSaveAssistant(typingRow, "スパムと検知されました、数日後に再度お試しください。");
        return { done: true };
      }

      const createdTypingRow = !typingRow;
      if (createdTypingRow) {
        appendMsg("user", bubble(msg));
        saveMessage("user", msg);
        const typing = typingBubble();
        typingRow = appendMsg("assistant", typing);
      } else {
        const inner = typingRow.querySelector(".ai-inner");
        inner.replaceChild(bubble(`スパム防止の為お待ちください、再試行します… (${retryCount}/3)`), inner.firstChild);
      }

      try{
        const history = getHistoryForServer();
        const sig = _sign();
        const reqBody = {
          message: msg,
          sessionId,
          history,
          model: "gpt-6-luna",
          _t: sig._t,
          _k: sig._k,
          source: "chat"
        };
        if (pageCtxOn) {
          const pageProduct = readPageProduct(true);
          if (pageProduct) reqBody.pageProduct = pageProduct;
        }
        const res = await fetch(WORKER_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reqBody),
        });

        let payload = {};
        try { payload = await res.json(); } catch(_){ payload = {}; }

        if(!res.ok){
          if (payload?.error === "DAILY_LIMIT_REACHED") {
            const text = (payload?.message || "24時間あたりの上限に達しました。") +
                         "\n解除するには特定のパスワードを送信してください。";
            renderAndSaveAssistant(typingRow, text);
            return { done: true };
          }
          if (payload?.error === "TOO_MANY_REQUESTS") {
            const sec = Number(payload?.retryAfterSec) || 10;
            const text = (payload?.message || "短時間に連続送信されています。") + `\n約 ${sec} 秒お待ちください。`;
            renderAndSaveAssistant(typingRow, text);
            return { done: true };
          }
          // 1時間・1日の上限やアクセス集中は再試行しても通らないので、理由をそのまま出して止める
          if (res.status === 429) {
            const text = (payload?.message || "ただいま混み合っています。しばらくしてから再度お試しください。") +
                         "\nお急ぎの場合は、下記のお問い合わせフォームからご連絡ください。\nhttps://www.titan-pc.net/pages/contact";
            renderAndSaveAssistant(typingRow, text);
            return { done: true };
          }
          if (retryCount < 3){
            const inner = typingRow.querySelector(".ai-inner");
            inner.replaceChild(bubble(`通信エラー。再試行します… (${retryCount+1}/3)`), inner.firstChild);
            setTimeout(()=> sendBase(msg, retryCount+1, typingRow), 1500);
            return { done:false, retrying:true };
          } else {
            renderAndSaveAssistant(typingRow, "再試行に失敗しました。再度お試しください。");
            return { done: true };
          }
        }

        let text = "普通のエラーです、再度お試しください。";
        for(const k of ["answer","reply","message","text"]){
          if(payload && typeof payload[k]==="string" && payload[k].trim()){ text=payload[k]; break; }
        }
        renderAndSaveAssistant(typingRow, text, payload && payload.products);
        lastSendTime = Date.now();
        return { done: true };

      }catch(err){
        if (retryCount < 3){
          const inner = typingRow.querySelector(".ai-inner");
          inner.replaceChild(bubble(`通信エラー。再試行します… (${retryCount+1}/3)`), inner.firstChild);
          setTimeout(()=> sendBase(msg, retryCount+1, typingRow), 1500);
          return { done:false, retrying:true };
        } else {
          renderAndSaveAssistant(typingRow, "再試行に失敗しました。再度お試しください。");
          return { done: true };
        }
      }
    }

    function syncSendState(){
      const elInput = qs("ai-input"), elSend = qs("ai-send");
      if (elInput && elSend) elSend.classList.toggle("is-empty", !(elInput.value || "").trim());
    }
    function setChipsDisabled(v){
      document.querySelectorAll("#ai-chips .ai-chip").forEach(b => { b.disabled = v; });
    }

    // overrideMsg: 質問チップから送る場合の文面（入力中の下書きは残す）
    async function send(overrideMsg){
      const elInput = qs("ai-input");
      const elSend  = qs("ai-send");
      const fromInput = typeof overrideMsg !== "string";
      const msg = (fromInput ? (elInput.value||"") : overrideMsg).trim();
      if(!msg) return;
      if(sending) return;
      if (pageCtxOn) renderPageCtx();

      elInput.disabled = true;
      elSend.disabled = true;
      setChipsDisabled(true);
      const prevPlaceholder = elInput.placeholder;
      if (fromInput) {
        elInput.placeholder = "送信中…";
        elInput.value = "";
        elInput.style.height = "";
      }
      syncSendState();

      if (isMobile()) {
        elInput.blur();
      }

      sending = true;

      await sendBase(msg, 0, null);

      elInput.disabled = false;
      elSend.disabled = false;
      setChipsDisabled(false);
      elInput.placeholder = prevPlaceholder;
      sending = false;
      syncSendState();

      if (!isMobile()) {
        elInput.focus();
      }
    }

    // 外部から確実に開くためのAPI（main-product.liquidなどから利用）
    window.titanOpenAI = function(prefillText){
      try {
        showPanel();
        if (typeof prefillText === "string" && prefillText) {
          setTimeout(function(){
            const input = qs("ai-input");
            if (input) {
              input.value = prefillText;
              if (window.titanAIAutosizeInput) window.titanAIAutosizeInput();
              if (!isMobile()) input.focus();
            }
          }, 150);
        }
      } catch(e) { /* no-op */ }
    };

    // 商品ページの「AIに質問する」：見ている商品を話題にした状態で開く
    window.titanAskProduct = function(){
      try {
        if (!pageCtxOn) switchMode(true);
        showPanel();
      } catch(e) { /* no-op */ }
    };
    document.addEventListener("click", e => {
      const t = e.target && e.target.closest ? e.target.closest("[data-tg-ai-ask]") : null;
      if (!t) return;
      e.preventDefault();
      window.titanAskProduct();
    });

    // 画面上のAI丸ボタン用。PCではパネル表示中も残し、同じボタンで閉じられるようにする。
    window.titanToggleAI = function(){
      try {
        const panel = qs("ai-panel");
        if (panel && panel.style.display === "grid") hidePanel();
        else showPanel();
      } catch(e) { /* no-op */ }
    };

    // 初期化
    function init(){
      qs("ai-bubble").onclick = () => {
        const panel = qs("ai-panel");
        if (panel.style.display === "grid") hidePanel();
        else showPanel();
      };
      qs("ai-close").onclick  = hidePanel;
      qs("ai-send").onclick   = send;
      qs("ai-input").addEventListener("keydown", e => {
        // Enter で送信 / Shift+Enter で改行 / 日本語の変換確定中は送信しない
        if (e.key !== "Enter") return;
        if (e.isComposing || e.keyCode === 229) return;
        if (e.shiftKey || e.altKey) return;
        e.preventDefault();
        send();
      });
      // textarea 自動リサイズ (内容に合わせて高さ調整)
      const _autosize = () => {
        const el = qs("ai-input");
        if (!el) return;
        el.style.height = "auto";
        el.style.height = Math.min(el.scrollHeight, 160) + "px";
        syncSendState();
      };
      qs("ai-input").addEventListener("input", _autosize);
      // 外部から value 設定された後にもautosizeを掛けられるよう公開
      window.titanAIAutosizeInput = _autosize;
      qs("ai-input").addEventListener("focus", syncSendState);
      qs("ai-chips").addEventListener("click", e => {
        const chip = e.target.closest(".ai-chip");
        if (!chip || chip.disabled || sending) return;
        const q = chip.getAttribute("data-q");
        if (q) send(q);
      });
      // 診断ページなど他のスクリプトが旧仕様の送信案内を入れた場合は現在の案内に戻す
      const inputEl = qs("ai-input");
      new MutationObserver(() => {
        if (/Shift\s*\+\s*Enter/.test(inputEl.placeholder)) inputEl.placeholder = pageCtxOn ? PRODUCT_PLACEHOLDER : DEFAULT_PLACEHOLDER;
      }).observe(inputEl, { attributes: true, attributeFilter: ["placeholder"] });

      qs("ai-clear").onclick = () => { clearHistory(); };
      qs("ai-ctx").querySelector(".ai-ctx-other").onclick = () => {
        if (switchMode(false) && !isMobile()) qs("ai-input").focus();
      };
      qs("ai-back").onclick = () => {
        if (switchMode(true) && !isMobile()) qs("ai-input").focus();
      };

      window.addEventListener("popstate", () => {
        if (qs("ai-panel").style.display === "grid") {
          hidePanel();
        }
      });

      // 商品ページでは最初から商品の相談として履歴を読む
      if (productHandle() && !pageCtxDismissed() && readPageProduct()) pageCtxOn = true;
      renderPageCtx();
      // オプションでCPUを変えると商品名(h1)が書き換わるので、チャット上部の商品名も追従させる
      const titleEl = document.querySelector("h1[data-titan-title]");
      if (titleEl && productHandle()) {
        let ctxTimer = 0;
        new MutationObserver(() => {
          clearTimeout(ctxTimer);
          ctxTimer = setTimeout(renderPageCtx, 150);
        }).observe(titleEl, { childList: true, characterData: true, subtree: true });
      }
      loadHistory();
setTimeout(()=> {
  // 過去の会話が残っている場合、会話の後ろに初回あいさつを足さない
  if (qs("ai-log").querySelector(".ai-msg")) return;
  appendGreeting();
}, 250)
    }

    init();
  });
})();
